import { Box } from '@wix/design-system';
import {
  GtmEvents,
  PackagePickerSteps,
  useGtmLogger,
} from '@wix/package-picker-shared';
import {
  Checkout,
  PageDisclaimer,
  TrustBuilders,
  useInitCheckoutPageBiEvents,
  useIsSeasonalSale,
  useIsStudioNewUi,
  useStudioPanorama,
  useViewChange,
} from '@wix/package-picker-shared-studio';
import React from 'react';
import { PageLayout } from '../../components';
import { TrustBuildersSection } from '../../components/TrustBuildersSection';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

export const CheckoutPage = () => {
  const handleViewChange = useViewChange();
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  useGtmLogger(GtmEvents.CHECKOUT);
  useInitCheckoutPageBiEvents();

  const handleBack = () => {
    StudioPackagePickerModule.internals.bi.onBackButtonClick?.({
      fromStep: 'checkout',
    });
    handleViewChange(PackagePickerSteps.SELECT_CYCLE, { cycleId: null });
  };
  const panorama = useStudioPanorama();
  const { ready } =
    StudioPackagePickerModule.internals.experiments.hooks.useExperiments();
  const isStudioNewUi = useIsStudioNewUi();
  const isSeasonalSale = useIsSeasonalSale();

  React.useEffect(() => {
    panorama.startTransaction('checkout-page-load');
  }, []);

  if (!ready) {
    return null;
  }

  if (isStudioNewUi) {
    return (
      <PageLayout
        onBack={handleBack}
        backButtonText={t('Advanced.Plans_Steps_Step2')}
      >
        <Box marginTop="SP7" direction="vertical" align="center" width="100%">
          <Checkout shouldOpenDoublePurchaseModal />
        </Box>
        {isSeasonalSale && (
          <Box
            width="100%"
            marginTop="72px"
            padding="0 40px"
            boxSizing="border-box"
            textAlign="center"
            align="center"
          >
            <PageDisclaimer />
          </Box>
        )}
        <TrustBuildersSection />
      </PageLayout>
    );
  }

  return (
    <PageLayout
      onBack={handleBack}
      backButtonText={t('Advanced.Plans_Steps_Step2')}
    >
      <Box margin="SP7 SP5 SP5 SP5">
        <Checkout shouldOpenDoublePurchaseModal />
      </Box>
      <PageDisclaimer />
      <TrustBuilders />
    </PageLayout>
  );
};
